import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
    //authorization: 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class UserControllerService {

  constructor(private http: HttpClient) { }

  private _getCandidates = environment.local + 'candidates/getcandidates';
  private _getCandidateInfo = environment.local + 'candidates/getcandidateinfo';
  private _saveImage = environment.local + 'candidates/saveprofilepicture';
  private _getCandidate = environment.local + 'candidates/getcandidate';
  private _getRecruiters = environment.local + 'recruiters/getrecruiters';
  private _getRecruiter = environment.local + 'recruiters/getrecruiter';
  private _getRecruiterInfo = environment.local + 'recruiters/getrecruiterinfo';
  private _changeUserStatus = environment.local + 'candidates/changeuserstatus';

  getCandidates(userCredentials) {
    return this.http.post<any>(this._getCandidates, userCredentials, httpOptions)
  }

  getCandidate(userData) {
    return this.http.post<any>(this._getCandidate, userData, httpOptions)
  }

  getCandidateInfo(userCredentials) {
    return this.http.post<any>(this._getCandidateInfo, userCredentials, httpOptions)
  }

  saveCandidateImage(userData) {
    return this.http.post<any>(this._saveImage, userData, httpOptions)
  }

  getRecruiters() {
    return this.http.post<any>(this._getRecruiters, httpOptions)
  }

  getRecruiter(userData) {
    return this.http.post<any>(this._getRecruiter, userData, httpOptions)
  }

  getRecruiterInfo(userCredentials) {
    return this.http.post<any>(this._getRecruiterInfo, userCredentials, httpOptions)
  }

  changeUserStatus(userCredentials) {
    return this.http.post<any>(this._changeUserStatus, userCredentials, httpOptions)
  }

}
